module.exports = __webpack_public_path__ + "img/f40.b5d87bd9.png";